import React from 'react';

export const LinkedInWhiteCircleSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1027, -20)" fill="#FFFFFF" fillRule="nonzero">
        <path d="M1047,20 C1058.04569,20 1067,28.954305 1067,40 C1067,51.045695 1058.04569,60 1047,60 C1035.95431,60 1027,51.045695 1027,40 C1027,28.954305 1035.95431,20 1047,20 Z M1052.8713,35.2088 C1050.5263,35.2088 1048.7875,36.5738 1048.4025,37.3963 L1048.35,37.3963 L1048.35,35.5 L1044.5,35.5 L1044.5,48.9169 L1048.5838,48.9169 L1048.5838,41.9169 C1048.5838,39.7644 1050.0475,38.8075 1051.4713,38.8075 C1052.6375,38.8075 1053.8338,39.7063 1053.8338,41.8644 L1053.8338,48.9169 L1057.9169,48.9169 L1057.9169,40.8788 C1057.9169,36.795 1055.2163,35.2088 1052.8713,35.2088 Z M1042.1669,35.5 L1038.0838,35.5 L1038.0838,48.9169 L1042.1669,48.9169 L1042.1669,35.5 Z M1040.1544,28.7044 C1038.8335,28.689 1037.7499,29.7467 1037.7338,31.0669 C1037.7177,32.3878 1038.7754,33.4714 1040.0963,33.4875 L1040.125,33.4875 C1041.4137,33.5204 1042.484,32.5026 1042.5169,31.2139 L1042.5169,31.125 C1042.533,29.8041 1041.4753,28.7205 1040.1544,28.7044 Z" />
      </g>
    </g>
  </svg>
);
